import { Grid } from '@mui/material';
import React, { useContext } from 'react';
import { IconContainer } from '../components/IconContainer/IconContainer';
import Content from '../components/Layout/Content';
import ApplicationContext from '../context/applicationContext';
import { FINANCIAL } from '../shared/Strings';

export const Financial = () => {
  const { menuItems } = useContext(ApplicationContext);

  return (
    <Content title={FINANCIAL.TITLE_TEXT} data-testid="financial-7">
      <Grid
        container
        spacing={3}
        sx={{ justifyContent: { xs: 'center', sm: 'left' } }}>
        {menuItems?.Financial?.subItems?.map(item => (
          <Grid item key={item.id}>
            <IconContainer
              route={item.route}
              imgUrl={item.icon}
              caption={item.category}
              origin={'standard'}
            />
          </Grid>
        ))}
      </Grid>
    </Content>
  );
};
